"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _components = require("components");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paymentLogos = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  color: _css.colors.gray,
  marginTop: "3em",
  marginBottom: "1.5em"
});

var paymentIconsContainer = (0, _glamor.css)({
  width: 200,
  overflow: "hidden"
});

var paymentIcons = (0, _glamor.css)({
  opacity: 0.25,
  width: 255
});

var PaymentLogos = function (_React$Component) {
  (0, _inherits3.default)(PaymentLogos, _React$Component);

  function PaymentLogos(props) {
    (0, _classCallCheck3.default)(this, PaymentLogos);
    return (0, _possibleConstructorReturn3.default)(this, (PaymentLogos.__proto__ || (0, _getPrototypeOf2.default)(PaymentLogos)).call(this, props));
  }

  (0, _createClass3.default)(PaymentLogos, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(
        "div",
        { className: paymentLogos },
        _react2.default.createElement(
          "div",
          { className: paymentIconsContainer },
          _react2.default.createElement("img", {
            alt: "Supported payment gateway logos",
            className: paymentIcons,
            src: props.paymentLogosSrc
          })
        ),
        _react2.default.createElement(
          "span",
          null,
          "Payments by",
          _react2.default.createElement(_components.TextButtonLibrary, {
            mode: "small-gray-underlined",
            href: props.braintreeLink,
            label: "Braintree",
            newWindow: true
          })
        )
      );
    }
  }]);
  return PaymentLogos;
}(_react2.default.Component);

exports.default = PaymentLogos;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentSettingsForm/components/PaymentLogos.jsx
// module id = 2531
// module chunks = 0